import { sqliteTable, text, integer, real } from "drizzle-orm/sqlite-core";
import { fleetVehicles } from "./vehicles";

// ============================================================================
// tax_records — ประวัติจ่ายภาษีรถ
// ============================================================================
export const taxRecords = sqliteTable("fleet_tax_records", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  vehicleId: text("vehicle_id").notNull().references(() => fleetVehicles.id),
  taxYear: integer("tax_year").notNull(),
  paymentDate: text("payment_date").notNull(),
  amount: real("amount").default(0),
  vendorName: text("vendor_name"),
  // #401 — Optional soft FK to accounting_partners.id; see garage_partner_id
  // comment on maintenance-records for rationale.
  vendorPartnerId: text("vendor_partner_id"),
  paymentMethod: text("payment_method"),
  receiptNo: text("receipt_no"),
  paymentId: text("payment_id"),
  documentUrl: text("document_url"),
  notes: text("notes"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type TaxRecord = typeof taxRecords.$inferSelect;
export type NewTaxRecord = typeof taxRecords.$inferInsert;
